// https://newrelic.com/blog/how-to-relic/nextjs-monitor-application-data
const logErrorToRelic = async (err) => {
    var _a;
    try {
        if (typeof window === 'undefined') {
            // SSR
            /* eslint-disable global-require */
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const newrelic = require('newrelic');
            newrelic.noticeError(err);
        }
        else {
            // Client
            (_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.noticeError(err);
        }
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const logImgLoadErrorToRelic = (pagePath, imgUrl) => logErrorToRelic(new Error(`Failed to load image. Page: ${pagePath}. Img: ${imgUrl}`));

export { logErrorToRelic, logImgLoadErrorToRelic };
//# sourceMappingURL=logToRelic.js.map
